import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled 
          ? 'bg-warm-white/95 backdrop-blur-md shadow-sm py-3' 
          : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 transition-all duration-300">
            <img
              src="https://customer-assets.emergentagent.com/job_f585ab8e-7cfc-40a9-9ad8-85709134c17e/artifacts/3suel8ih_Black%20And%20White%20Minimalist%20Typography%20Personal%20Logo.png"
              alt="Kensetsu Limited"
              className={`w-auto transition-all duration-300 ${
                isScrolled ? 'h-10' : 'h-12'
              }`}
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="text-warm-charcoal hover:text-burgundy transition-colors duration-300 font-manrope font-medium text-base"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-warm-charcoal hover:text-burgundy transition-colors duration-300 font-manrope font-medium text-base"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-warm-charcoal hover:text-burgundy transition-colors duration-300 font-manrope font-medium text-base"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="text-warm-charcoal hover:text-burgundy transition-colors duration-300 font-manrope font-medium text-base"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="bg-navy text-warm-white px-6 py-3 rounded-lg hover:bg-burgundy transition-all duration-300 font-manrope font-medium text-base shadow-sm hover:shadow-md hover:translate-y-[-2px]"
            >
              Book Consultation
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 text-warm-charcoal hover:text-burgundy transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-2 animate-fade-up">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-3 text-warm-charcoal hover:bg-sand/50 rounded-lg transition-all duration-300 font-manrope"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left px-4 py-3 text-warm-charcoal hover:bg-sand/50 rounded-lg transition-all duration-300 font-manrope"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left px-4 py-3 text-warm-charcoal hover:bg-sand/50 rounded-lg transition-all duration-300 font-manrope"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className="block w-full text-left px-4 py-3 text-warm-charcoal hover:bg-sand/50 rounded-lg transition-all duration-300 font-manrope"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left px-4 py-3 bg-navy text-warm-white rounded-lg hover:bg-burgundy transition-all duration-300 font-manrope font-medium"
            >
              Book Consultation
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
